import { useEffect, useState } from "react";

import { PATIENTS_SEARCH_QUERY } from "components/patient-search/patient-search.component";
import { PATIENT_TYPE, PHYSICIAN_TYPE } from "constants/referral_sources";
import { useLazyGetPatientQuery } from "services/patients";
import { useLazyGetPhysicianQuery } from "services/physicians";
import { useGetReferralSourceQuery } from "services/referral-sources";

export default function useSubReferralSourceObject(
  id: number | null | undefined,
  referredType: string | null | undefined
) {
  const [currentSubReferralSourceObject, setCurrentSubReferralSourceObject] =
    useState<any>(null);
  const { data: subReferralSource } = useGetReferralSourceQuery(Number(id), {
    skip: !Boolean(id)
  });
  const [getPatient] = useLazyGetPatientQuery();
  const [getPhysician] = useLazyGetPhysicianQuery();
  useEffect(() => {
    if (Boolean(id)) {
      if (referredType === PATIENT_TYPE && subReferralSource?.object_id) {
        getPatient({
          patientId: subReferralSource?.object_id,
          query: PATIENTS_SEARCH_QUERY
        }).then(({ data: patient }) => {
          setCurrentSubReferralSourceObject({
            ...patient,
            content_type: referredType
          });
        });
      } else if (
        referredType === PHYSICIAN_TYPE &&
        subReferralSource?.object_id
      ) {
        getPhysician(subReferralSource?.object_id).then(
          ({ data: physician }) => {
            setCurrentSubReferralSourceObject({
              ...physician,
              content_type: referredType
            });
          }
        );
      } else {
        setCurrentSubReferralSourceObject(subReferralSource);
      }
    } else {
      setCurrentSubReferralSourceObject(null);
    }
  }, [
    id,
    subReferralSource?.object_id,
    referredType,
    getPatient,
    getPhysician,
    subReferralSource
  ]);

  return currentSubReferralSourceObject;
}
